import styled from 'styled-components';
import theme from "../../Themes/light";
import { ThemeType } from '../../types/Theme';

const TableProdutosContainer = styled.div
    <{ theme: ThemeType, colunasVariacao: number, template: 'principal' | 'impressao', temImagem: boolean, temColunaProduto: boolean }>`
    width: 90%;

    table{
        min-width: 100%;
        thead{
            tr{
                th{
                    color: ${({ theme }) => theme.colors.tertiary};
                    margin-bottom: 1rem;
                    text-align: center;
                    min-width: 10rem;
                    
                    &.align-left{
                        text-align: left;
                    }
                }
            }
        }
        tfoot{
            tr{
                td{
                    padding: 0;
                    border: none;
                }
            }
            .flex-footer{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 3rem;
                font-weight: bold;
                .info{
                    color: ${({ theme }) => theme.colors.tertiary};
                    display: flex;
                    svg{
                        margin-right: 0.5rem;
                        width: 2rem;
                        fill: ${({ theme }) => theme.colors.secondary};
                    }
                }
            }
        }
        .row-simulated {
            display: grid;
            grid-template-columns: ${({ colunasVariacao, temColunaProduto }) => {
                if (temColunaProduto && colunasVariacao > 0) {
                    return `1fr repeat(${colunasVariacao}, minmax(8rem, 12.5%))`;
                } else if (temColunaProduto) {
                    return '1fr';
                } else if (colunasVariacao > 0) {
                    return `repeat(${colunasVariacao}, 1fr)`;
                }
                return '1fr';
            }};
            column-gap: 1rem;
            .produtos {
                text-align: left;
            };   

            @media (max-width: 768px) {
                grid-template-columns: ${({ colunasVariacao, temColunaProduto }) => {
                    if (temColunaProduto && colunasVariacao > 0) {
                        return `200px repeat(${colunasVariacao}, 100px)`;
                    } else if (temColunaProduto) {
                        return '1fr';
                    } else if (colunasVariacao > 0) {
                        return `repeat(${colunasVariacao}, 1fr)`;
                    }
                    return '1fr';
                }};
                column-gap: 0.5rem;
            }
            }

            .flex-produto {
                width: 100%;
                display: ${({ temImagem }) => temImagem ? 'grid' : 'block'};
                grid-template-columns: ${({ temImagem }) => temImagem ? '15rem auto' : 'auto'};
                gap: 2rem;
                align-items: start;
                justify-items: start;
                text-align: left;
                color: ${({ theme }) => theme.colors.tertiary};
        
                .produto-imagem {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    .imagem-produto-container{
                        width: 100%;
                        border-radius: 2rem;
                        overflow: hidden;
                        > img {
                            cursor: pointer;
                            width: 100%;
                            height: 15rem;
                            object-fit: scale-down;
                        }
                    }
                }
                .informacoes-produto{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    gap: 1rem;
                    padding-right: 2rem;
                    line-height: normal;
                    @media (max-width: 768px) {
                        width: 22rem;
                    }
                    .descricao{
                        p{
                            margin: 0;
                        }
                        *{
                            line-height: 1.2;
                        }
                    }
                }
            }
            
            .flex-variacoes{
                height: auto;
                min-width: 10rem;
                text-align: center;
                display: flex;
                align-items: flex-end;
                color: ${({ theme }) => theme.colors.tertiary};
                padding-top: 1rem;

                span{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &.align-left{
                        flex-direction: column;
                    }
                    svg{
                        margin-left: 0.5rem;
                        width: 2rem;
                        fill: ${({ theme }) => theme.colors.secondary};
                    }
                }

                .preco-container{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 0.2rem;
                }

                .preco-original{
                    font-size: 0.85em;
                    text-decoration: line-through;
                    opacity: 0.7;
                }

                &.com-swatch{
                    align-items: stretch;
                }
                .variacao-linha{
                    display: grid;
                    grid-template-columns: auto minmax(0, 1fr);
                    grid-template-rows: minmax(0, 1fr);
                    align-items: stretch;
                    justify-content: start;
                    column-gap: 1rem;
                }
                .variacao-swatch{
                    display: block;
                    width: auto;
                    height: 100%;
                    aspect-ratio: 1 / 1;
                    contain: size;
                    align-self: center;
                    min-width: 2.4rem;
                    min-height: 2.4rem;
                    max-width: 6rem;
                    max-height: 6rem;
                    border-radius: 0.6rem;
                    border: 1px solid ${({ theme }) => theme.colors.elements};
                    background-color: var(--swatch-cor, transparent);
                    object-fit: cover;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .variacao-texto{
                    width: auto;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    text-align: left;
                }
            }
            .observacao{
                position: relative;
                padding-bottom: 1rem;
                grid-column: ${({ colunasVariacao }) => colunasVariacao > 0 ? `span ${colunasVariacao}` : 'span 1'};
                min-width: 100%;
                width: min-content;
                text-align: left;
                span{
                    width: 100%;
                    position: relative;
                    display: inline-block;
                    color: ${({ theme }) => theme.colors.tertiary};
                }
                .separator-line-obs{
                    position: absolute;
                    top: calc(100% - 2px);
                    left: 0;
                    width: 100%;
                    height: 2px;
                    border-radius: 50px;
                    background-color: ${({ theme }) => theme.colors.elements};
                }
            }
        .separator-line{
            grid-column: 1 / -1;
            width: 100%;
            height: 2px;
            margin: 1rem 0;
            border-radius: 50px;
            background-color: ${({ theme }) => theme.colors.elements};
        }
    }
    @media print{
        width: 100%;
        page-break-before: avoid;
        table{
            thead{
                tr{
                    th{
                        color: ${theme.colors.tertiary} !important;
                        margin-bottom: 5px;
                    }
                }
            }
            tfoot{
                .flex-footer{
                    gap: 12px;
                    font-weight: bold !important;
                    margin-top: 10px;
                    .info{
                        color: ${theme.colors.tertiary} !important;
                    }
                }
            }
            .row-simulated{
                grid-template-columns: ${({ colunasVariacao, temColunaProduto }) => {
                    if (temColunaProduto && colunasVariacao > 0) {
                        return `1fr repeat(${colunasVariacao}, minmax(50px, 13%))`;
                    } else if (temColunaProduto) {
                        return '1fr';
                    } else if (colunasVariacao > 0) {
                        return `repeat(${colunasVariacao}, 1fr)`;
                    }
                    return '1fr';
                }};
                .flex-produto {
                    display: ${({ temImagem }) => temImagem ? 'grid' : 'block'};
                    grid-template-columns: ${({ temImagem }) => temImagem ? '75px auto' : 'auto'};
                    gap: 15px;
                    color: ${theme.colors.tertiary} !important;
                    .produto-imagem {
                        .imagem-produto-container{
                            border-radius: 15px;
                            > img {
                                cursor: pointer;
                                width: 100%;
                                height: 75px;
                                object-fit: scale-down;
                            }
                        }
                    }
                    .informacoes-produto{
                        color: ${theme.colors.tertiary} !important;
                        gap: 5px;
                        line-height: 1.2;
                        padding-right: 10px;
                        div{
                            color: ${theme.colors.tertiary} !important;
                            b{
                                color: ${theme.colors.tertiary} !important;
                            }
                        }
                        .descricao{
                            color: ${theme.colors.tertiary} !important;
                            *{
                                color: ${theme.colors.tertiary} !important;
                                margin: 0;
                                line-height: 1.2;
                            }
                        }
                    }
                }
            }
            .separator-line{
                height: 1px;
                /* margin: 5px 0; */
                /* border-radius: 50px; */
                background-color: ${theme.colors.tertiary} !important;
                &:last-of-type, &:first-of-type{
                    display: block;
                }
            }
            .flex-variacoes{
                text-align: center;
                color: ${theme.colors.tertiary} !important;
                padding-top: 8px;
                span{
                    text-align: center;
                    color: ${theme.colors.tertiary} !important;
                }
                .preco-container{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 1px;
                }
                .preco-original{
                    font-size: 0.85em;
                    text-decoration: line-through;
                    opacity: 0.7;
                }
                .variacao-linha{
                    column-gap: 6px;
                }
                .variacao-swatch{
                    min-width: 16px;
                    min-height: 16px;
                    max-width: 40px;
                    max-height: 40px;
                    border-radius: 4px;
                    border-color: ${theme.colors.elements} !important;
                    background-color: var(--swatch-cor, transparent) !important;
                }
                .variacao-texto{
                    text-align: left;
                }
            }
            .observacao{
                padding-bottom: 10px;
                span{
                    b{
                        color: ${theme.colors.tertiary} !important;
                    }
                    color: ${theme.colors.tertiary} !important;
                }
                .separator-line-obs{
                    height: 1px;
                    background-color: ${theme.colors.elements} !important;
                }
            }
        }
    }
`;

export {
    TableProdutosContainer
};

